import styles from "./Pipeline.module.css";
import { Board } from "@caldwell619/react-kanban";
import "@caldwell619/react-kanban/dist/styles.css";
import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import "./CustomBoard.css";
import { HiOutlineCheckCircle } from "react-icons/hi";
import { CiLock } from "react-icons/ci";
import { Button, Dropdown, Menu } from "antd";
import { PiDotsThreeCircleLight } from "react-icons/pi";
import EnterpriseServices from "../../../../../services/EnterpriseServices";
import useNotification from "../../../../../hooks/useNotification";
import CandidateServices from "../../../../../services/CandidateServices";

const CustomUncontrolledBoard = styled(Board)`
  && .react-kanban-board {
    background-color: #0d2159 !important;
  }

  && .react-kanban-card-adder-button {
    display: none;
  }
`;

var shortListsDND = [];
var interViewedListDND = [];
var offeredCandidates = [];
var rejectedCandDND = [];
var selectedListDND = [];

const Pipeline = (props) => {
  const [loading, setLoading] = useState(false);
  const [candidateData, setCandidateData] = useState([]);
  const { showNotification } = useNotification();

  const [board, setBoard] = useState({
    columns: [
      {
        id: "shortlisted", // Set the ID for the Favorited column
        title: "Shortlisted",
        cards: [],
      },
      {
        id: "interviewed", // Set the ID for the Shortlist column
        title: "Interviewed",
        cards: [],
      },
      {
        id: "selected", // Set the ID for the Interviewed column
        title: "Selected",
        cards: [],
      },
      {
        id: "offered", // Set the ID for the Selected column
        title: "Offer Extended",
        cards: [],
      },
      {
        id: "rejected", // Set the ID for the Selected column
        title: "Rejected",
        cards: [],
      },
    ],
  });

  const jobData = props.data;
  const fetchCandidates = async () => {
    setLoading(true);
    try {
      var payload = {
        jobID: jobData._id,
      };
      const res = await EnterpriseServices.getJobCandidatesById(jobData._id);
      if (res) {
        if (res.statusCode === 1) {
          const applicantsData = res.data.slice().reverse();

          if (applicantsData) {
            let fetchedCandidatesListData = applicantsData.map((person) => {
              let paidForKyc = false;
              if (person.candidateData?.indexscores_payments) {
                let payments = person.candidateData?.indexscores_payments;
                for (let i = 0; i < payments.length; i++) {
                  const element = payments[i];
                  if (element.enterpriseId === person?.enterpriseData?._id) {
                    paidForKyc = true;
                  }
                }
              }

              return {
                id: person.candidateID,
                applicantID: person._id,
                paidForKyc: paidForKyc,
                cat: "all",
                relevanceScoreVal: Math.round(
                  person.relevanceScore?.[payload.jobID]
                ),
                tagClass: person.score
                  ? paidForKyc && person.kycVerification
                    ? "high"
                    : "pending"
                  : "pending",
                tagTitle:
                  Math.round(person.relevanceScore?.[payload.jobID]) <= 33
                    ? "low"
                    : Math.round(person.relevanceScore?.[payload.jobID]) > 33 &&
                      Math.round(person.relevanceScore?.[payload.jobID]) <= 66
                    ? "average"
                    : "high",
                name: person.candidateName,
                pronouns: "He/him",
                date: person.createdAt,
                indexCore: person.score
                  ? paidForKyc && person.kycVerification
                    ? Math.round(person.indexScore)
                    : 2
                  : 1,
                CultureFit: person.score
                  ? paidForKyc && person.kycVerification
                    ? Math.round(person.culturefit?.[person.company_Name])
                    : 2
                  : 1,
                indexColor: "main",
                candidatePhoneNumber: "+" + person.candidatePhoneNumber,
                candidateEmail: person.candidateEmail,
                jobLocation: person.company_Name,
                country: person.country,
                jobCompany: person.company_Name,
                jobId: person.jobID,
                jobTitle: person.job_title,
                resumeUrl: person.candidateResume.Key,
                managerID: person.managerID,
                color: "red",
                team_members: person.team_members,
                interviewers: person.interviewersID,
                status: person.status,
                applicationData: person,
                show_indexscore: person.show_indexscore,
                score_request: person.score ? person.score : false,
                kycVerification: person.kycVerification
                  ? person.kycVerification
                  : false,
                Descriptions:
                  "BreifCover letter of job/position here of job/position here Description of job/position here Description here of job/position here. Description of job/position here of job/position here Description of job/position here.",
                profileImage: person.candidateData
                  ? person?.candidateData?.profileImage?.docs
                  : "/assets/images/user.svg",
              };
            });
            setCandidateData([...fetchedCandidatesListData]);
            setLoading(false);
          }
        } else {
          handleError(`${res.statusDesc}`);
        }
      }
    } catch (error) {
      console.log(error);
      if (error.statusCode === 0) {
        console.log("Error while updating info", error);
        handleError(error.description);
      } else {
        handleError("Error: Member info is not updated.");
      }
    }
  };

  const handleError = (error) => {
    setLoading(false);
    showNotification(error, "error");
  };

  useEffect(() => {
    if (jobData._id) {
      fetchCandidates();
    }
  }, [jobData._id]);

  useEffect(() => {
    updatingBoard();
  }, [candidateData]);

  shortListsDND = candidateData.filter(
    (candidate) => candidate.status === "shortlisted" // Replace 'favorite' with the desired status value
  );

  interViewedListDND = candidateData.filter(
    (candidate) =>
      candidate.status === "interviewd" || candidate.status === "interviewed" // Replace 'favorite' with the desired status value
  );

  offeredCandidates = candidateData.filter(
    (candidate) => candidate.status === "offered" // Replace 'favorite' with the desired status value
  );

  rejectedCandDND = candidateData.filter(
    (candidate) => candidate.status === "rejected" // Replace 'favorite' with the desired status value
  );

  selectedListDND = candidateData.filter(
    (candidate) => candidate.status === "selected" // Replace 'favorite' with the desired status value
  );

  const updatingBoard = () => {
    const updatedColumns = board.columns.map((column) => {
      let updatedCards = column.cards;

      if (column.id === "shortlisted") {
        updatedCards = shortListsDND.map((item) => ({
          id: item.id,
          title: item.name,
          description: "Index Score " + item.indexCore,
          assigneeId: item.applicantID,
          completeData: item,
        }));
      } else if (column.id === "interviewed") {
        updatedCards = interViewedListDND.map((item) => ({
          id: item.id,
          title: item.name,
          description: "Index Score " + item.indexCore,
          assigneeId: item.applicantID,
          completeData: item,
        }));
      } else if (column.id === "selected") {
        updatedCards = selectedListDND.map((item) => ({
          id: item.id,
          title: item.name,
          description: "Index Score " + item.indexCore,
          assigneeId: item.applicantID,
          completeData: item,
        }));
      } else if (column.id === "rejected") {
        updatedCards = offeredCandidates.map((item) => ({
          id: item.id,
          title: item.name,
          description: "Index Score " + item.indexCore,
          assigneeId: item.applicantID,
          completeData: item,
        }));
      } else if (column.id === "offered") {
        updatedCards = rejectedCandDND.map((item) => ({
          id: item.id,
          title: item.name,
          description: "Index Score " + item.indexCore,
          assigneeId: item.applicantID,
          completeData: item,
        }));
      }

      return {
        ...column,
        title: column.title, // You can keep the title the same if it's not changing
        cards: updatedCards,
      };
    });

    setBoard({ columns: updatedColumns });
  };

  const updateStatus = async (candidateID, status) => {
    // alert(candidateID);
    try {
      var payloadOffered = {
        _id: candidateID,
        status: status,
      };
      const response = await CandidateServices.UpdateCandidateStatus(
        payloadOffered
      );
      if (response) {
        if (response.statusCode === 1) {
          fetchCandidates();
          showNotification(`Status Updated`);
        } else {
          handleError(`${response.statusDesc}`);
        }
      }
    } catch (error) {
      console.error("Error fetching access token:", error);
      showNotification(`Status not updated`);
    }
  };

  const handleCardMove = async (
    sourceColumnId,
    destinationColumnId,
    sourceCardId
  ) => {
    console.warn(
      "sourceColumnId",
      sourceColumnId,
      destinationColumnId,
      sourceCardId
    );
    handleUpdate();

    let boardData = board.columns;
    boardData = boardData.map((item) => {
      if (item.id === destinationColumnId.fromColumnId) {
        console.warn("item.cards", item.cards, item);

        item.cards = item.cards.filter((obj) => obj.id !== sourceColumnId.id);
      }

      if (item.id === sourceCardId.toColumnId) {
        item.cards.push(sourceColumnId);
        console.warn("item.cards", item.cards, item);
      }

      return item;
    });

    setBoard({ columns: boardData });

    await updateStatus(
      sourceColumnId.completeData.applicantID,
      sourceCardId.toColumnId
    );
  };

  const handleUpdate = () => {};

  return (
    <div className={styles.content_wrap + " enteprise_page"}>
      <CustomUncontrolledBoard
        removeColumn={false}
        disableHeaderEdit={true}
        disableColumnRemoval={true}
        onCardDragEnd={handleCardMove}
        disableColumnDrag={true}
        renameColumn={false}
        onCardRemove={({ board, card, column }) => {
          console.log({ board, card, column });
        }}
        renderColumnHeader={(column) => {
          const totalCardsCount = column.cards.length; // Calculate total cards count
          return (
            <div className={styles.header_wrap} key={column.id}>
              <div className={`${styles[column.id]} ${styles.dot}`}></div>
              {column.title}

              <span className={styles.count_wrap}>{totalCardsCount}</span>
            </div>
          );
        }}
        renderCard={(card) => {
          return (
            <div className={`${styles.card_wrap} card_content`} key={card._id}>
              <div className={styles.name_bar}>
                <div className={styles.name_wrap}>
                  <img
                    src={
                      card.completeData.applicationData.candidateProfileImg.docs
                    }
                    className={styles.img_wrap}
                    alt=""
                  />
                  <div className={styles.name}>{card.completeData.name}</div>
                </div>
                <Dropdown
                  placement="top"
                  overlay={
                    <Menu>
                      <Menu.Item
                        key="delete"
                        className="text-decoration-none darkGrey d-flex align-items-center"
                      >
                        View Profile
                      </Menu.Item>
                    </Menu>
                  }
                >
                  <PiDotsThreeCircleLight className={styles.icon} />
                </Dropdown>
              </div>

              <div className={styles.columns_wrap}>
                <div>
                  <p>Indexscore</p>
                  <div>
                    {" "}
                    {card.completeData?.score_request ? (
                      card.completeData?.kycVerification ? (
                        <div className={styles.badge}>
                          {card.completeData.applicationData.indexScore}
                        </div>
                      ) : (
                        <span>Pending</span>
                      )
                    ) : (
                      <>
                        <span>Hidden</span>
                      </>
                    )}
                  </div>
                </div>

                <div>
                  <p>Purpose</p>
                  {card.completeData.CultureFit === 1 ||
                  card.completeData.CultureFit === 2 ? (
                    <span>Pending</span>
                  ) : (
                    <div className={styles.badge}>
                      {card.completeData.CultureFit}%
                    </div>
                  )}
                </div>

                <div>
                  <p>Relevence</p>
                  <div> {card.completeData.relevanceScoreVal}%</div>
                </div>

                <div>
                  <p>Verified</p>
                  {card.completeData.applicationData.score &&
                  card.completeData.paidForKyc &&
                  card.completeData.kycVerification ? (
                    <div className={styles.verified_cell}>
                      <HiOutlineCheckCircle className="high__icon fs-6" />
                    </div>
                  ) : (
                    <span>Pending</span>
                  )}
                </div>
              </div>
            </div>
          );
        }}
      >
        {board}
      </CustomUncontrolledBoard>
    </div>
  );
};

export default Pipeline;
